import styled from '@emotion/styled'

const fontFamily = "'IBM Plex Sans Thai', sans-serif"

export const PurchaseGroupMenuContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '10px',
  flexWrap: 'wrap',
  flex: 1,
  fontFamily,

  '*, .ui, .ui input, .ui.button, .MuiTypography-root': {
    fontFamily: `${fontFamily} !important`,
  },

  '.ui.input input': {
    fontFamily: `${fontFamily} !important`,
  },

  '.cardMenu': {
    width: '200px', 
    height: 'auto',
    margin: '0px 10px 10px 0px',
    cursor: 'pointer',

    '.MuiTypography-root': {
      fontWeight: 500,
    },

    '.MuiCardContent-root:last-child': {
      padding: '0px',
    },
  }
})

export const PurchaseGroupMenuContainer2 = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '10px',
  flexWrap: 'wrap',
  flex: 1,

  form: { 
    display: 'flex', 
    width: '100%', 
    flexWrap: 'wrap',

    'div.ui.card': {
      margin: 0, 
      marginRight: 10, 
      marginBottom: 10, 
      minWidth: 200, 
      width: '23%',

      '.content': {
        '.header': {
          fontSize: '1.25rem',
          fontFamily: 'inherit',
          whiteSpace: 'normal',
          wordWrap: 'break-word',
        },
      },
    },
  },

  '.cardMenu': {
    width: '200px', 
    height: 'auto',
    margin: '0px 10px 10px 0px',
    cursor: 'pointer',

    '.MuiCardContent-root:last-child': {
      padding: '0px',
    },
  }
})

export const SubCategoryContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  fontSize: '1rem',
  fontFamily,
  fontWeight: 600,
  padding: '5px 10px',
  borderTop: 'solid 1px #EEE',

  '&:hover': {
    background: '#EFEFEF',
  },

  '&:last-child': {
    paddingBottom: '10px'
  },
})
